import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { useUserCardProvider } from '../../../../../utilities/sharedHooks/user';
import { cardProviders } from '../../../../../screens/Card/constants';

const MAPPING = {
  [cardProviders.MONAVATE]: {
    x: 35,
    y: 165,
    fontSize: 13,
  },
};
export function ValidUntilDate({ cardValidThrough = null }) {
  const { cardProvider } = useUserCardProvider();
  const { x = 45, y = 130, fontSize = 16 } = MAPPING[cardProvider] || {};

  const validUntilDate = useMemo(() => {
    if (cardValidThrough) {
      if (cardProvider === cardProviders.MONAVATE) {
        const date = cardValidThrough.split('/');
        const month = date?.length > 0 ? date[1] : '00';
        const year = date?.length > 0 ? date[0].slice(2, 4) : '00';

        return `${month}/${year}`;
      }
      return `${cardValidThrough?.slice(0, 2)}/${cardValidThrough?.slice(2, 4)}`;
    }
    return null;
  }, [cardProvider, cardValidThrough]);

  if (validUntilDate) {
    return (
      <g>
        <text fill="#191919" fontWeight="500" fontSize={fontSize} x={x} y={y}>
          {validUntilDate}
        </text>
      </g>
    );
  }
  return <></>;
}
ValidUntilDate.propTypes = {
  cardValidThrough: PropTypes.string,
};
export default ValidUntilDate;
